import * as React from 'react';
import {RangeType} from "rsuite/DateRangePicker";
import moment from "moment/moment";
import {DateRangePicker} from "rsuite";

export type DateRanges = 'Today' | 'Yesterday' | '2 Days Ago' | 'Last 7 Days' | 'Month to Date' | 'Month to Yesterday' | 'Last 30 Days' | 'Last Month' | '7 to 45 Days' | 'Last 60 Days' | 'Last 6 Month' | 'Last 12 Month' | 'Last 24 Month' | 'Year to Date'

const RANGE_BUILDERS: Record<string, () => [Date, Date]> = {
    'Today': () => [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
    'Yesterday': () => [moment().subtract(1, "day").startOf("day").toDate(), moment().subtract(1, "day").endOf("day").toDate()],
    '2 Days Ago': () => [moment().subtract(2, "day").startOf("day").toDate(), moment().subtract(2, "day").endOf("day").toDate()],
    'Last 7 Days': () => [moment().subtract(7, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    'Month to Date': () => [moment().startOf("month").toDate(), moment().endOf("day").toDate()],
    'Month to Yesterday': () => [moment().startOf("month").toDate(), moment().subtract(1, "day").endOf("day").toDate()],
    'Last 30 Days': () => [moment().subtract(30, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    'Last Month': () => [moment().subtract(1, "month").startOf("month").toDate(), moment().subtract(1, "month").endOf("month").toDate()],
    '7 to 45 Days': () => [moment().subtract(45, "days").startOf("day").toDate(), moment().endOf("day").subtract(8, "days").toDate()],
    'Last 60 Days': () => [moment().subtract(60, "days").startOf("day").toDate(), moment().endOf("day").toDate()],
    'Last 6 Month': () => [moment().subtract(6, "month").startOf("month").toDate(), moment().subtract(1, "month").endOf("month").toDate()],
    'Last 12 Month': () => [moment().subtract(12, "month").startOf("month").toDate(), moment().subtract(1, "month").endOf("month").toDate()],
    'Last 24 Month': () => [moment().subtract(24, "month").startOf("month").toDate(), moment().subtract(1, "month").endOf("month").toDate()],
    'Year to Date': () => [moment().startOf("year").toDate(), moment().endOf("day").toDate()],
};

const rangePlacement = () => (window.innerWidth < 768 ? 'bottom' : 'left') as 'bottom' | 'left';

export const buildPredefinedRanges = (): RangeType[] =>
    Object.keys(RANGE_BUILDERS).map((label) => ({
        label,
        value: RANGE_BUILDERS[label](),
        placement: rangePlacement(),
    }));

const predefinedRanges: RangeType[] = buildPredefinedRanges();
export default function DateRange({showTime = true, dateRange, setDateRange, style, placement}:{showTime?: boolean, dateRange: any, setDateRange: any, style: any, placement?: 'bottomStart' | 'bottomEnd'}) {
    let j= 0;
    const ranges = React.useMemo(() => buildPredefinedRanges(), []);
    return (
            <DateRangePicker
                format={showTime ? "MM-dd-yyyy HH:mm:ss" : "MM-dd-yyyy"}
                value={dateRange}
                showOneCalendar={window.innerWidth < 768}
                ranges={ranges}
                onChange={(value: any) => { if (value[1].getHours() === 0) {value[1].setHours(23, 59, 59)} setDateRange(value)}}
                cleanable={false}
                preventOverflow={false}
                style={style}
                placement={window.innerWidth < 768 ? 'bottomStart' : (placement || 'bottomStart')}
                onFocus={(e: any) => {j++; if (j === 1) { e.target.blur(); }}}
                onExit={(e: any) => {j = 0;}}
            />
    )
}

export const RangeToTimes = (defaultRange: DateRanges) => {
    return RANGE_BUILDERS[defaultRange]?.() ?? predefinedRanges.filter((range: RangeType) => range.label === defaultRange)[0]?.value;
}

export const getDateRangeByLabel = (label: string): Date[] | null => {
    const build = RANGE_BUILDERS[label];
    if (build) return build();
    const match = predefinedRanges.find((range) => range.label === label);
    if (!match?.value) return null;
    return [match.value[0], match.value[1]];
}
